import type { DataTableColumn as GridColDef } from '@/components/custom/erp';
import { formatDate, formatMoney } from '@/lib/formatUtils';

export const invoiceReportColumns = (handleDocumentFormClick: (obj: BanHangRecord) => void): GridColDef[] => [
  {
    field: 'ma_unit',
    headerName: 'Đơn vị',
    width: 140
  },
  {
    field: 'ngay_ct3',
    headerName: 'Ngày c/từ',
    width: 110,
    renderCell: params => formatDate(params.row.ngay_ct3)
  },
  {
    field: 'so_ct3',
    headerName: 'Số c/từ',
    width: 200,
    renderCell: params => (
      <button onClick={() => handleDocumentFormClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {params.row.so_ct3}
      </button>
    )
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày xuất',
    width: 110,
    renderCell: params => formatDate(params.row.ngay_ct)
  },
  {
    field: 'so_ct',
    headerName: 'Số c/từ xuất',
    width: 200,
    renderCell: params => params.row.so_ct
  },
  {
    field: 'ngay_ct0',
    headerName: 'Ngày hóa đơn',
    width: 120,
    renderCell: params => formatDate(params.row.ngay_ct0)
  },
  {
    field: 'so_ct0',
    headerName: 'Số hóa đơn',
    width: 150,
    renderCell: params => (
      <button onClick={() => handleDocumentFormClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {params.row.so_ct0}
      </button>
    )
  },
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 140
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 200,
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 250
  },
  {
    field: 'ma_vt',
    headerName: 'Mã vật tư',
    width: 120
  },
  {
    field: 'ten_vt',
    headerName: 'Tên vật tư',
    width: 240
  },
  {
    field: 'dvt',
    headerName: 'ĐVT',
    width: 120
  },
  {
    field: 'sl_nhap_xuat',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'sl_km',
    headerName: 'SL bán KM',
    width: 100,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'ma_thue',
    headerName: 'Mã thuế',
    width: 150
  },
  {
    field: 'gia2',
    headerName: 'Giá bán',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'tien2',
    headerName: 'Doanh thu',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'thue',
    headerName: 'Thuế',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'ck',
    headerName: 'Chiết khấu',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'doanh_thu_thuan',
    headerName: 'Doanh thu thuần',
    width: 140,
    type: 'number',
    valueGetter: (value, row) => formatMoney((row.tien2 || 0) - (row.ck || 0)),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'pt',
    headerName: 'Phải thu',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'gia',
    headerName: 'Giá vốn',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'tien_von',
    headerName: 'Tiền vốn',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'loi_nhuan',
    headerName: 'Lợi nhuận gộp',
    width: 120,
    type: 'number',
    valueGetter: (value, row) => formatMoney((row.tien2 || 0) - (row.ck || 0) - (row.tien_von || 0)),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'ln_dt',
    headerName: '%LN/DT',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'ln_tv',
    headerName: '%LN/TV',
    width: 120,
    type: 'number',
    valueGetter: value => formatMoney(value),
    cellClassName: params => (!params.row.stt ? 'font-bold' : '')
  },
  {
    field: 'ma_nvbh',
    headerName: 'Mã nv bán hàng',
    width: 120
  },
  {
    field: 'ten_nvbh',
    headerName: 'Tên nv bán hàng',
    width: 250
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120
  },
  {
    field: 'tk_vt',
    headerName: 'Tk vật tư',
    width: 120
  },
  {
    field: 'tk_dt',
    headerName: 'Tk doanh thu',
    width: 120
  },
  {
    field: 'tk_gv',
    headerName: 'Tk giá vốn',
    width: 120
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 130
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 100
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 130
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 130
  },
  {
    field: 'ma_ct',
    headerName: 'Mã c/từ',
    width: 120
  }
];
